var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseURLLocation } from "@/models/Utility";
import * as EmailValidator from "email-validator";
import moment from "moment";
import { CARRIER_CODE, PAYMENT_LOGS_SORT_OPTIONS, SORT_BY_OPTIONS } from "./Constants";
export const isValidEmail = (email) => {
    return EmailValidator.validate(email);
};
export const getCarrierIcon = (carrierCode) => {
    switch (carrierCode && carrierCode.toLowerCase()) {
        case CARRIER_CODE.DHL.toLowerCase(): {
            return require("../assets/Orders/dhl-1-logo-png-transparent.png").default;
        }
        case CARRIER_CODE.FEDEX.toLowerCase(): {
            return require("../assets/Orders/fedex-logo-42681.png").default;
        }
        case CARRIER_CODE.FedExDefault.toLowerCase(): {
            return require("../assets/Orders/fedex-logo-42681.png").default;
        }
        case CARRIER_CODE.BLUE_DART.toLowerCase(): {
            return "https://cdn.ship24.com/assets/images/db/couriers/logo/bluedart.png";
        }
        case CARRIER_CODE.SHIPPIT.toLowerCase(): {
            return "https://upload.wikimedia.org/wikipedia/commons/b/be/Shipt_logo.svg";
        }
        case CARRIER_CODE.USPS.toLowerCase(): {
            return require("../assets/Orders/bridgeport-apartments-usps-png-logo-2.png").default;
        }
        case CARRIER_CODE.UPS.toLowerCase(): {
            return require("../assets/Orders/ups-logo-transparent-4275.png").default;
        }
        case CARRIER_CODE.UPSDAP.toLowerCase(): {
            return require("../assets/Orders/ups-logo-transparent-4275.png").default;
        }
        case CARRIER_CODE.Delhivery.toLowerCase(): {
            return require("../assets/Orders/delhivery.png").default;
        }
        case CARRIER_CODE.Xpressbess.toLowerCase(): {
            return require("../assets/Orders/Xpressbees.png").default;
        }
        case CARRIER_CODE.Ecom.toLowerCase(): {
            return require("../assets/Orders/Ecom.png").default;
        }
        case CARRIER_CODE.DTDC.toLowerCase(): {
            return require("../assets/Orders/dtdc_logo_2.png").default;
        }
        case CARRIER_CODE.DTDC_B2B.toLowerCase(): {
            return require("../assets/Orders/dtdc-b2b.png").default;
        }
        case CARRIER_CODE.BLITZ.toLowerCase(): {
            return require("../assets/Orders/blitz.svg").default;
        }
        case CARRIER_CODE.ZIPPYYSHADOWFAX.toLowerCase(): {
            return require("../assets/Orders/shadowfax.png").default;
        }
        case CARRIER_CODE.ZIPPYYXEKART.toLowerCase(): {
            return require("../assets/Orders/ekart_logistics_logo.png").default;
        }
        case CARRIER_CODE.ZIPPYYXDELHIVERY.toLowerCase(): {
            return require("../assets/Orders/delhivery.png").default;
        }
        case CARRIER_CODE.ZIPPYYXSHREEMARUTI.toLowerCase(): {
            return require("../assets/Orders/shreemaruti.png").default;
        }
        case CARRIER_CODE.ZIPPYYEBLUEDART.toLowerCase(): {
            return "https://cdn.ship24.com/assets/images/db/couriers/logo/bluedart.png";
        }
        case CARRIER_CODE.ZIPPYYEEKART.toLowerCase(): {
            return require("../assets/Orders/ekart_logistics_logo.png").default;
        }
        case CARRIER_CODE.ZIPDASH.toLowerCase(): {
            return require("../assets/Orders/zipdash.png").default;
        }
        case CARRIER_CODE.SHIPNEXADELHIVERY.toLowerCase(): {
            return require("../assets/Orders/delhivery.png").default;
        }
        case CARRIER_CODE.ZYPDASH.toLowerCase(): {
            return require("../assets/Orders/zipdash.png").default;
        }
        case CARRIER_CODE.ATSHEAVY.toLowerCase(): {
            return require("../assets/Orders/ats.svg").default;
        }
        case CARRIER_CODE.ATSBAU.toLowerCase(): {
            return require("../assets/Orders/ats.svg").default;
        }
        case CARRIER_CODE.ATS.toLowerCase(): {
            return require("../assets/Orders/ats.svg").default;
        }
        default: {
            return "";
        }
    }
};
export const getNextDateAfterCertainDays = (startDate, daysToAdd) => {
    if (!startDate || startDate === "") {
        return "-";
    }
    const [day, month, year] = startDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    let addedDays = 0;
    while (addedDays < daysToAdd) {
        // If it's not Saturday (6) or Sunday (0), count the day
        if (date.getDay() !== 0) {
            addedDays++;
        }
        // Only move to the next day if we haven't reached the required daysToAdd
        if (addedDays < daysToAdd) {
            date.setDate(date.getDate() + 1);
        }
    }
    // Format the date back to "dd-mm-yyyy"
    const formattedDate = date
        .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    })
        .split("/")
        .join("-");
    if (formattedDate === "Invalid date") {
        return "-";
    }
    return formattedDate;
};
export const getNextDayDate = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const tomorrow = new Date(today);
    if (dayOfWeek >= 0 && dayOfWeek <= 5) {
        tomorrow.setDate(today.getDate() + 1);
    }
    else if (dayOfWeek === 6) {
        tomorrow.setDate(today.getDate() + 2);
    }
    const day = String(tomorrow.getDate()).padStart(2, "0");
    const month = String(tomorrow.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = tomorrow.getFullYear();
    return `${day}-${month}-${year}`;
};
export const getDateString = (timestamp, format) => {
    if (isNaN(timestamp))
        return "-";
    if (timestamp) {
        // Convert timestamp to Moment.js object
        const date = moment(timestamp);
        // Format the date according to the desired format
        const formattedDate = date.format(format);
        return formattedDate;
    }
    else {
        return "-";
    }
};
export const getCurrencyByCode = (code) => {
    if (code === "INR") {
        return "₹";
    }
    return code;
};
export const getDateStringByString = (timestamp, format) => {
    if (timestamp) {
        // Convert timestamp to Moment.js object
        const date = moment(Number(timestamp));
        // Format the date according to the desired format
        const formattedDate = date.isValid() ? date.format(format) : "-";
        return formattedDate;
    }
    else {
        return "-";
    }
};
export const getNewDateString = (timestamp) => {
    if (!timestamp)
        return { date: "-", time: "-" };
    const date = moment(timestamp);
    return {
        date: date.format("Do MMM YY"), // e.g. 23rd Mar 23
        time: date.format("hh:mm A"), // e.g. 03:45 PM
    };
};
export const validatePhoneNumberInput = (value) => {
    const regex = /^[0-9]*$/;
    return regex.test(value) || value === "";
};
export const validateEmailInput = (email) => {
    // Regular expression for basic email validation
    return (!/(\.{2}|-{2}|_{2})/.test(email) && /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(email));
};
export const getCountryBaseNameFromUrl = () => {
    const url = window.location.pathname;
    let location = "";
    [BaseURLLocation.in, BaseURLLocation.us, BaseURLLocation.za].forEach((country) => {
        if (url.startsWith(country)) {
            location = country;
            return;
        }
    });
    return location;
};
export const ADDRESS_REGEX = /^[a-zA-Z0-9\/,.-]+$/;
export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
export const NUMERIC_REGEX = /^[0-9]+$/;
export const ALPHA_REGEX = /^[a-zA-Z]+$/;
export const forbiddenKeys = ["Control", "Shift", "Delete", "Backspace", " "];
export const EMAIL_REGEX = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/;
export const PHONE_NUMBER_REGEX = /^\+(?:[0-9] ?){6,14}[0-9]$/;
export var ValidationType;
(function (ValidationType) {
    ValidationType["address"] = "Address";
    ValidationType["numeric"] = "Number";
    ValidationType["alpha"] = "Alpha";
    ValidationType["alphaNumeric"] = "AlphaNumeric";
    ValidationType["email"] = "Email";
    ValidationType["phoneNumber"] = "PhoneNumber";
})(ValidationType || (ValidationType = {}));
export const getOrderValue = (rate) => {
    var _a, _b, _c, _d;
    return (Number(((_a = rate === null || rate === void 0 ? void 0 : rate.shipmentPaymentDetails) === null || _a === void 0 ? void 0 : _a.subTotal) || 0.0) +
        Number(((_b = rate === null || rate === void 0 ? void 0 : rate.shipmentPaymentDetails) === null || _b === void 0 ? void 0 : _b.otherCharges) || 0.0) +
        Number(((_c = rate === null || rate === void 0 ? void 0 : rate.shipmentPaymentDetails) === null || _c === void 0 ? void 0 : _c.shippingCharges) || 0.0) -
        Number(((_d = rate === null || rate === void 0 ? void 0 : rate.shipmentPaymentDetails) === null || _d === void 0 ? void 0 : _d.discount) || 0.0)).toFixed(2);
};
export const getOrderValueFromOrder = (order) => {
    var _a, _b, _c, _d;
    return (Number(((_a = order === null || order === void 0 ? void 0 : order.shippingProperties) === null || _a === void 0 ? void 0 : _a.subTotal) || 0.0) +
        Number(((_b = order === null || order === void 0 ? void 0 : order.shippingProperties) === null || _b === void 0 ? void 0 : _b.otherCharges) || 0.0) +
        Number(((_c = order === null || order === void 0 ? void 0 : order.shippingProperties) === null || _c === void 0 ? void 0 : _c.shippingCharges) || 0.0) -
        Number(((_d = order === null || order === void 0 ? void 0 : order.shippingProperties) === null || _d === void 0 ? void 0 : _d.discount) || 0.0)).toFixed(2);
};
export const getFilteredShipments = (shipments, carrier, orderSourceP, paymentTypeP, minAmountP, maxAmountP, minWeightP, maxWeightP, orderNumbersStrP, AWBstrP, tagStrP, rtoReceivedP) => {
    var _a;
    let ordersComing = shipments;
    if (rtoReceivedP === "true") {
        ordersComing = shipments.filter((item) => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.tags) === null || _a === void 0 ? void 0 : _a.includes("zp_rto_received"); });
    }
    else if (rtoReceivedP === "false") {
        ordersComing = shipments.filter((item) => { var _a; return !((_a = item === null || item === void 0 ? void 0 : item.tags) === null || _a === void 0 ? void 0 : _a.includes("zp_rto_received")); });
    }
    if (orderSourceP !== "") {
        ordersComing = shipments.filter((item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.orderSourceCode) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === (orderSourceP === null || orderSourceP === void 0 ? void 0 : orderSourceP.toLocaleLowerCase()); });
    }
    if (paymentTypeP !== "") {
        ordersComing = ordersComing.filter((item) => { var _a, _b; return ((_b = (_a = item === null || item === void 0 ? void 0 : item.shipmentPaymentDetails) === null || _a === void 0 ? void 0 : _a.orderType) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) === (paymentTypeP === null || paymentTypeP === void 0 ? void 0 : paymentTypeP.toLocaleLowerCase()); });
    }
    if (minAmountP !== "") {
        ordersComing = ordersComing.filter((item) => {
            const orderValue = getOrderValue(item);
            return Number(orderValue) >= Number(minAmountP);
        });
    }
    if (maxAmountP !== "") {
        ordersComing = ordersComing.filter((item) => {
            const orderValue = getOrderValue(item);
            return Number(orderValue) <= Number(maxAmountP);
        });
    }
    if (minWeightP != "") {
        ordersComing = ordersComing.filter((item) => {
            var _a;
            return Number((_a = item === null || item === void 0 ? void 0 : item.parcel) === null || _a === void 0 ? void 0 : _a.weight) >= Number(minWeightP);
        });
    }
    if (maxWeightP != "") {
        ordersComing = ordersComing.filter((item) => {
            var _a;
            return Number((_a = item === null || item === void 0 ? void 0 : item.parcel) === null || _a === void 0 ? void 0 : _a.weight) <= Number(maxWeightP);
        });
    }
    if (orderNumbersStrP != "") {
        const orderNumbers = orderNumbersStrP.replace(/\s+/g, "").split(",");
        let ordersFiltered = [];
        orderNumbers.forEach((orderNumber) => {
            const temp = ordersComing.filter((item) => orderNumber === item.orderNumber);
            ordersFiltered = [...ordersFiltered, ...temp];
        });
        ordersComing = ordersFiltered;
    }
    if (AWBstrP != "") {
        const AWBs = AWBstrP.replace(/\s+/g, "").split(",");
        let ordersFiltered = [];
        AWBs.forEach((awb) => {
            const temp = ordersComing.filter((item) => awb === item.trackingCode);
            ordersFiltered = [...ordersFiltered, ...temp];
        });
        ordersComing = ordersFiltered;
    }
    if (tagStrP !== "") {
        let ordersFiltered = [];
        (_a = tagStrP === null || tagStrP === void 0 ? void 0 : tagStrP.replace(/\s+/g, "")) === null || _a === void 0 ? void 0 : _a.split(",").forEach((tag) => {
            const temp = ordersComing.filter((item) => { var _a, _b, _c; return (ordersFiltered === null || ordersFiltered === void 0 ? void 0 : ordersFiltered.indexOf(item)) === -1 && ((_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.tags) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "")) === null || _b === void 0 ? void 0 : _b.split(",")) === null || _c === void 0 ? void 0 : _c.indexOf(tag)) >= 0; });
            ordersFiltered = [...ordersFiltered, ...temp];
        });
        ordersComing = ordersFiltered;
    }
    return ordersComing;
};
// Sorting function
export const sortOrders = (orders, sortBy) => {
    return orders.sort((a, b) => {
        var _a, _b, _c, _d;
        if (sortBy === SORT_BY_OPTIONS.CREATED_AT) {
            return a.createdAt.localeCompare(b.createdAt);
        }
        else if (sortBy === SORT_BY_OPTIONS.UPDATED_AT) {
            return a.modifiedAt.localeCompare(b.modifiedAt);
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_TYPE) {
            return a.shippingProperties.deliveryType.localeCompare(b.shippingProperties.deliveryType);
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_SOURCE) {
            return a.channel.type.localeCompare(b.channel.type);
        }
        else if (sortBy === SORT_BY_OPTIONS.RECEIVER_STATE) {
            return (a.destination.state || "").localeCompare(b.destination.state || "");
        }
        else if (sortBy === SORT_BY_OPTIONS.PICKUP_LOCATION) {
            return (a.origin.state || "").localeCompare(b.origin.state || "");
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_AMOUNT_H_TO_L) {
            return Number(getOrderValueFromOrder(b)) - Number(getOrderValueFromOrder(a));
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_AMOUNT_L_TO_H) {
            return Number(getOrderValueFromOrder(a)) - Number(getOrderValueFromOrder(b));
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_NUMBER_H_TO_L) {
            return Number((_a = b === null || b === void 0 ? void 0 : b.metadata) === null || _a === void 0 ? void 0 : _a.orderNumber) - Number((_b = a === null || a === void 0 ? void 0 : a.metadata) === null || _b === void 0 ? void 0 : _b.orderNumber);
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_NUMBER_L_TO_H) {
            return Number((_c = a === null || a === void 0 ? void 0 : a.metadata) === null || _c === void 0 ? void 0 : _c.orderNumber) - Number((_d = b === null || b === void 0 ? void 0 : b.metadata) === null || _d === void 0 ? void 0 : _d.orderNumber);
        }
        return 0;
    });
};
export const sortShipments = (orders, sortBy) => {
    return orders.sort((a, b) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (sortBy === SORT_BY_OPTIONS.CREATED_AT) {
            return a.createdAt.toLocaleString().localeCompare(b.createdAt.toLocaleString());
        }
        else if (sortBy === SORT_BY_OPTIONS.UPDATED_AT) {
            return a.updatedAt.toLocaleString().localeCompare(b.updatedAt.toLocaleString());
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_TYPE) {
            return (_a = a.shipmentPaymentDetails) === null || _a === void 0 ? void 0 : _a.orderType.localeCompare((_b = b.shipmentPaymentDetails) === null || _b === void 0 ? void 0 : _b.orderType);
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_SOURCE) {
            return a.orderSourceCode.localeCompare(b.orderSourceCode);
        }
        else if (sortBy === SORT_BY_OPTIONS.RECEIVER_STATE) {
            return (a.toAddress.state || "").localeCompare(b.toAddress.state || "");
        }
        else if (sortBy === SORT_BY_OPTIONS.PICKUP_LOCATION) {
            return (a.fromAddress.state || "").localeCompare(b.fromAddress.state || "");
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_AMOUNT_H_TO_L) {
            return Number(getOrderValue(b)) - Number(getOrderValue(a));
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_AMOUNT_L_TO_H) {
            return Number(getOrderValue(a)) - Number(getOrderValue(b));
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_NUMBER_H_TO_L) {
            return Number(b === null || b === void 0 ? void 0 : b.orderNumber) - Number(a === null || a === void 0 ? void 0 : a.orderNumber);
        }
        else if (sortBy === SORT_BY_OPTIONS.ORDER_NUMBER_L_TO_H) {
            return Number(a === null || a === void 0 ? void 0 : a.orderNumber) - Number(b === null || b === void 0 ? void 0 : b.orderNumber);
        }
        else if (sortBy === SORT_BY_OPTIONS.CARRIER) {
            return (((_c = a.selectedRate) === null || _c === void 0 ? void 0 : _c.carrier) || "").localeCompare(((_d = b.selectedRate) === null || _d === void 0 ? void 0 : _d.carrier) || "");
        }
        else if (sortBy === SORT_BY_OPTIONS.PICKUP_DATE) {
            const dateA = new Date((_f = (_e = a.selectedRate) === null || _e === void 0 ? void 0 : _e.earliest_pickup_date) === null || _f === void 0 ? void 0 : _f.split("-").reverse().join("-"));
            const dateB = new Date((_h = (_g = b.selectedRate) === null || _g === void 0 ? void 0 : _g.earliest_pickup_date) === null || _h === void 0 ? void 0 : _h.split("-").reverse().join("-"));
            return dateB.valueOf() - dateA.valueOf();
        }
        else if (sortBy === SORT_BY_OPTIONS.EST_DELIVERY_DATE || sortBy === SORT_BY_OPTIONS.DELIVERED_DATE) {
            const [dayA, monthA, yearA] = (((_j = a === null || a === void 0 ? void 0 : a.selectedRate) === null || _j === void 0 ? void 0 : _j.earliest_pickup_date)
                ? getNextDateAfterCertainDays((_k = a === null || a === void 0 ? void 0 : a.selectedRate) === null || _k === void 0 ? void 0 : _k.earliest_pickup_date, (_l = a === null || a === void 0 ? void 0 : a.selectedRate) === null || _l === void 0 ? void 0 : _l.est_delivery_days)
                : getNextDateAfterCertainDays(getNextDayDate(), (_m = a === null || a === void 0 ? void 0 : a.selectedRate) === null || _m === void 0 ? void 0 : _m.est_delivery_days))
                .split("-")
                .map(Number);
            const [dayB, monthB, yearB] = (((_o = b === null || b === void 0 ? void 0 : b.selectedRate) === null || _o === void 0 ? void 0 : _o.earliest_pickup_date)
                ? getNextDateAfterCertainDays((_p = b === null || b === void 0 ? void 0 : b.selectedRate) === null || _p === void 0 ? void 0 : _p.earliest_pickup_date, (_q = b === null || b === void 0 ? void 0 : b.selectedRate) === null || _q === void 0 ? void 0 : _q.est_delivery_days)
                : getNextDateAfterCertainDays(getNextDayDate(), (_r = b === null || b === void 0 ? void 0 : b.selectedRate) === null || _r === void 0 ? void 0 : _r.est_delivery_days))
                .split("-")
                .map(Number);
            const dateA = new Date(yearA, monthA - 1, dayA);
            const dateB = new Date(yearB, monthB - 1, dayB);
            // Compare the epoch time (latest to oldest)
            return dateB.valueOf() - dateA.valueOf();
        }
        return 0;
    });
};
// Sorting function
export const sortPayment = (orders, sortBy) => {
    return orders.sort((a, b) => {
        if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.UPDATED_AT) {
            return a.modifiedAt.localeCompare(b.modifiedAt);
        }
        else if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.ORDER_AMOUNT_H_TO_L) {
            return Number(b === null || b === void 0 ? void 0 : b.totalPrice) - Number(a === null || a === void 0 ? void 0 : a.totalPrice);
        }
        else if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.ORDER_AMOUNT_L_TO_H) {
            return Number(a === null || a === void 0 ? void 0 : a.totalPrice) - Number(b === null || b === void 0 ? void 0 : b.totalPrice);
        }
        else if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.ORDER_NUMBER_H_TO_L) {
            return Number(b === null || b === void 0 ? void 0 : b.orderNumber) - Number(a === null || a === void 0 ? void 0 : a.orderNumber);
        }
        else if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.ORDER_NUMBER_L_TO_H) {
            return Number(a === null || a === void 0 ? void 0 : a.orderNumber) - Number(b === null || b === void 0 ? void 0 : b.orderNumber);
        }
        else if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.DESCRIPTION_A_TO_Z) {
            return a.paidFor.localeCompare(b.paidFor);
        }
        else if (sortBy === PAYMENT_LOGS_SORT_OPTIONS.DESCRIPTION_Z_TO_A) {
            return Number(b === null || b === void 0 ? void 0 : b.paidFor) - Number(a === null || a === void 0 ? void 0 : a.paidFor);
        }
        return 0;
    });
};
export const formatDateRangeForBillingCycle = (dateRange) => {
    if (dateRange === "Till Date") {
        return "Till Date";
    }
    if (!dateRange || typeof dateRange !== "string") {
        return "-----";
    }
    function getFormattedDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const suffix = day % 10 === 1 && day !== 11 ? "st" : day % 10 === 2 && day !== 12 ? "nd" : day % 10 === 3 && day !== 13 ? "rd" : "th";
        return `${day}${suffix} ${month}, ${year}`;
    }
    const formattedStart = getFormattedDate(dateRange);
    return formattedStart;
};
export const capitalizeFirstLetter = (str) => {
    if (str === "")
        return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const handleDownload = (data, extension) => {
    let type = extension === "pdf" ? "application/pdf" : extension === "png" ? "image/png" : `application/${extension}`;
    if (extension === "xlsx")
        type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (extension === "docx")
        type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // ← add this
    const blobData = data instanceof Uint8Array ? new Blob([new Uint8Array(data)], { type }) : data;
    const url = window.URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = url;
    link.download = `report.${extension}`;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
};
export const detectFileTypeFromBlob = (blob) => __awaiter(void 0, void 0, void 0, function* () {
    const buffer = yield blob.slice(0, 4).arrayBuffer();
    const bytes = new Uint8Array(buffer);
    const hex = Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
    if (hex.startsWith("25504446"))
        return "pdf"; // %PDF
    if (hex.startsWith("504b0304"))
        return "docx"; // PK.. (zip container — docx/xlsx/pptx all start this way)
    return "unknown";
});
